import { render, staticRenderFns } from "./ProofDetailsPage.vue?vue&type=template&id=775898c7&scoped=true&"
import script from "./ProofDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProofDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProofDetailsPage.vue?vue&type=style&index=0&id=775898c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775898c7",
  null
  
)

export default component.exports